import axios from "axios";
import ApiService from "./api.service";
// import authService from "./auth.service";
import ErrorService from "./error.service";
class HttpService {
    /**
    * GET Request.
    *
    * @param {string} path request path.
    * @return {Promise<void | AxiosResponse<any>>} axios response or void.
    */
    get(path) {
        return axios.get(ApiService.apiUrl(path), this.headers())
            .catch((error) => ErrorService.handle(error))
            .finally(() => { });
    }
    /**
    * PUT Request.
    *
    * @param {string} path request path.
    * @param {any} data request data.
    * @return {Promise<void | AxiosResponse<any>>} axios response or void.
    */
    put(path, data) {
        return axios.put(ApiService.apiUrl(path), data, this.headers())
            .catch((error) => ErrorService.handle(error))
            .finally(() => { });
    }
    /**
    * POST Request.
    *
    * @param {string} path request path.
    * @param {any} data request data.
    * @return {Promise<void | AxiosResponse<any>>} axios response or void.
    */
    post(path, data) {
        return axios.post(ApiService.apiUrl(path), data, this.headers())
            .catch((error) => ErrorService.handle(error))
            .finally(() => { });
    }
    /**
    * DELETE Request.
    *
    * @param {string} path request path.
    * @return {Promise<void | AxiosResponse<any>>} axios response or void.
    */
    delete(path) {
        return axios.delete(ApiService.apiUrl(path), this.headers())
            .catch((error) => ErrorService.handle(error))
            .finally(() => { });
    }
    headers() {
        return {
            // headers: { 'Authorization': `Bearer ${authService.getAccessToken()}` }
            headers: {}
        };
    }
}
export default new HttpService();
